"use strict";
/**
 * Created on 07 03 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * <p>Wrapper, which encapsulates {@link SelloutTerminationSummaryItem summary items} related to {@link SelloutTermination}.</p>
 *
 * @see {@link SelloutTerminationSummaryItem} for more info.
 * @author JMe
 */


var SelloutTerminationSummary =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutTerminationSummary, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param id Identification of summary.
   * @param terminationId Corresponds to {@link SelloutTermination.id}.
   * @param items List of associated {@link SelloutTerminationSummaryItem}.
   */
  function SelloutTerminationSummary(id, terminationId, items) {
    var _this;

    _classCallCheck(this, SelloutTerminationSummary);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationSummary).call(this));
    _this.id = id;
    _this.terminationId = terminationId;
    _this.items = items;
    return _this;
  }

  return SelloutTerminationSummary;
}(DomainObject_1.DomainObject);

exports.SelloutTerminationSummary = SelloutTerminationSummary;